var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { ref: "funding-information", attrs: { "lazy-validation": "" } },
    [
      _c(
        "v-row",
        { staticClass: "pa-5" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _vm.readonly
                ? [
                    _c("label", { staticClass: "primary--text" }, [
                      _vm._v(
                        "19. Ich habe meinen Hauptwohnsitz in Deutschland (vor dem 01.Juli 2021 gemeldet) und bin berechtigt, hier meine freiberufliche oder auf Produktionsdauer begrenzte künstlerische Tätigkeit auszuüben"
                      )
                    ]),
                    _c("p", { staticClass: "text-preview" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formData.hauptwohnsitz_deutschalnd ? "Ja" : "Nein"
                        )
                      )
                    ])
                  ]
                : _c("v-checkbox", {
                    attrs: {
                      label:
                        "19. Ich habe meinen Hauptwohnsitz in Deutschland (vor dem 01.Juli 2021 gemeldet) und bin berechtigt, hier meine freiberufliche oder auf Produktionsdauer begrenzte künstlerische Tätigkeit auszuüben",
                      dense: "",
                      rules: [_vm.rules.required]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue(
                          "hauptwohnsitz_deutschalnd",
                          v
                        )
                      }
                    },
                    model: {
                      value: _vm.formData.hauptwohnsitz_deutschalnd,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "hauptwohnsitz_deutschalnd", $$v)
                      },
                      expression: "formData.hauptwohnsitz_deutschalnd"
                    }
                  })
            ],
            2
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("label", { staticClass: "d-block primary--text ml-8" }, [
                _vm._v(
                  "20. Aktuell gültiger Reisepass UND aktuell gültige Meldebestätigung ODER Kopie des gültigen Personalausweises (Vorder- und Rückseite zusammen als ein PDF, max. 4MB)"
                )
              ]),
              _vm.readonly
                ? [
                    _c("p", { staticClass: "text-preview ml-8" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formData.datei_reisepass
                            ? _vm.formData.datei_reisepass.name
                            : ""
                        )
                      )
                    ])
                  ]
                : _c("v-file-input", {
                    attrs: {
                      accept: "application/pdf",
                      dense: "",
                      outlined: "",
                      rules: [
                        _vm.rules.required,
                        _vm.rules.valid_file_size(4),
                        _vm.rules.valid_file(_vm.fileCodes.ID_CARD)
                      ]
                    },
                    on: {
                      change: function(v) {
                        return _vm.onSelectFile("datei_reisepass", v)
                      }
                    },
                    model: {
                      value: _vm.formData.datei_reisepass,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "datei_reisepass", $$v)
                      },
                      expression: "formData.datei_reisepass"
                    }
                  })
            ],
            2
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _vm.readonly
                ? [
                    _c("label", { staticClass: "primary--text" }, [
                      _vm._v(
                        "21. Ich habe einen Wahrnehmungsvertrag mit der GVL (optional)"
                      )
                    ]),
                    _c("p", { staticClass: "text-preview mb-1" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formData.wahrnehmungsvertrag_gvl ? "Ja" : "Nein"
                        )
                      )
                    ])
                  ]
                : _c("v-checkbox", {
                    attrs: {
                      label:
                        "21. Ich habe einen Wahrnehmungsvertrag mit der GVL (optional)",
                      dense: ""
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("wahrnehmungsvertrag_gvl", v)
                      }
                    },
                    model: {
                      value: _vm.formData.wahrnehmungsvertrag_gvl,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "wahrnehmungsvertrag_gvl", $$v)
                      },
                      expression: "formData.wahrnehmungsvertrag_gvl"
                    }
                  }),
              !_vm.formData.wahrnehmungsvertrag_gvl
                ? _c("p", { staticClass: "hint-label ml-8 mb-0" }, [
                    _vm._v(
                      "Sie haben noch keinen Wahrnehmungsvertrag mit der GVL? "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "https://www.gvl.de/rechteinhaber/kuenstler/online-wahrnehmungsvertrag",
                          target: "blank"
                        }
                      },
                      [
                        _vm._v(
                          "Hier können Sie Ihren Vertrag online abschließen"
                        )
                      ]
                    ),
                    _vm._v(
                      "\n– die Mitgliedschaft in der GVL ist natürlich kostenfrei. Sollten Sie soeben online einen Wahrnehmungsvertrag mit der GVL geschlossen haben, so finden Sie Ihre GVL-ID auf der als PDF übermittelten Vertragsausfertigung."
                    )
                  ])
                : _vm._e()
            ],
            2
          ),
          _vm.formData.wahrnehmungsvertrag_gvl
            ? _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _vm.readonly
                    ? _c("div", { staticClass: "ml-8" }, [
                        _c("label", { staticClass: "primary--text" }, [
                          _vm._v(
                            "21.a. Ich bin bei der GVL unter der folgenden Nummer registriert: Bitte GVL-ID oder Vertragsnummer angeben"
                          )
                        ]),
                        _c("p", { staticClass: "text-preview" }, [
                          _vm._v(
                            _vm._s(_vm.formData.wahrnehmungsvertrag_gvl_id)
                          )
                        ])
                      ])
                    : _c("v-text-field", {
                        staticClass: "ml-8",
                        attrs: {
                          label:
                            "21.a. Ich bin bei der GVL unter der folgenden Nummer registriert: Bitte GVL-ID oder Vertragsnummer angeben",
                          autocomplete: "off",
                          outlined: "",
                          dense: "",
                          rules: [_vm.rules.required]
                        },
                        on: {
                          input: function(v) {
                            return _vm.saveFieldValue(
                              "wahrnehmungsvertrag_gvl_id",
                              v
                            )
                          }
                        },
                        model: {
                          value: _vm.formData.wahrnehmungsvertrag_gvl_id,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formData,
                              "wahrnehmungsvertrag_gvl_id",
                              $$v
                            )
                          },
                          expression: "formData.wahrnehmungsvertrag_gvl_id"
                        }
                      })
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _vm.readonly
                ? [
                    _c("label", { staticClass: "primary--text" }, [
                      _vm._v(
                        "22. Ich bin bei der Künstlersozialkasse (KSK) (optional)"
                      )
                    ]),
                    _c("p", { staticClass: "text-preview" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formData.kuenstlersozialkasse ? "Ja" : "Nein"
                        )
                      )
                    ])
                  ]
                : _c("v-checkbox", {
                    attrs: {
                      label:
                        "22. Ich bin bei der Künstlersozialkasse (KSK) (optional)",
                      dense: ""
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("kuenstlersozialkasse", v)
                      },
                      change: function(v) {
                        return _vm.saveFieldValue("kuenstlersozialkasse", v)
                      }
                    },
                    model: {
                      value: _vm.formData.kuenstlersozialkasse,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "kuenstlersozialkasse", $$v)
                      },
                      expression: "formData.kuenstlersozialkasse"
                    }
                  })
            ],
            2
          ),
          _vm.formData.kuenstlersozialkasse
            ? _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _vm.readonly
                    ? _c("div", { staticClass: "ml-8" }, [
                        _c("label", { staticClass: "primary--text" }, [
                          _vm._v(
                            "22.a. Ich bin bei der KSK unter der folgenden Nummer registriert"
                          )
                        ]),
                        _c("p", { staticClass: "text-preview" }, [
                          _vm._v(_vm._s(_vm.formData.kuenstlersozialkasse_id))
                        ])
                      ])
                    : _c("v-text-field", {
                        staticClass: "ml-8",
                        attrs: {
                          label:
                            "22.a. Ich bin bei der KSK unter der folgenden Nummer registriert",
                          autocomplete: "off",
                          outlined: "",
                          dense: "",
                          rules: [_vm.rules.required]
                        },
                        on: {
                          input: function(v) {
                            return _vm.saveFieldValue(
                              "kuenstlersozialkasse_id",
                              v
                            )
                          }
                        },
                        model: {
                          value: _vm.formData.kuenstlersozialkasse_id,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formData,
                              "kuenstlersozialkasse_id",
                              $$v
                            )
                          },
                          expression: "formData.kuenstlersozialkasse_id"
                        }
                      })
                ],
                1
              )
            : _vm._e(),
          _vm.formData.kuenstlersozialkasse
            ? _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _vm.readonly
                    ? _c("div", { staticClass: "ml-8" }, [
                        _c("label", { staticClass: "primary--text" }, [
                          _vm._v(
                            "22.b. Bitte KSK-Mitgliedsnachweis nicht älter als 2019 hochladen (PDF mit max. 4MB)"
                          )
                        ]),
                        _c("p", { staticClass: "text-preview" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formData.datei_kuenstlersozialkasse
                                ? _vm.formData.datei_kuenstlersozialkasse.name
                                : ""
                            )
                          )
                        ])
                      ])
                    : _c("v-file-input", {
                        class: _vm.readonly && "ml-8",
                        attrs: {
                          label:
                            "22.b. Bitte KSK-Mitgliedsnachweis nicht älter als 2019 hochladen (PDF mit max. 4MB)",
                          outlined: "",
                          dense: "",
                          accept: "application/pdf",
                          rules: [
                            _vm.rules.required,
                            _vm.rules.valid_file_size(4),
                            _vm.rules.valid_file(_vm.fileCodes.KSK_PROOF)
                          ]
                        },
                        on: {
                          change: function(v) {
                            return _vm.onSelectFile(
                              "datei_kuenstlersozialkasse",
                              v
                            )
                          }
                        },
                        model: {
                          value: _vm.formData.datei_kuenstlersozialkasse,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formData,
                              "datei_kuenstlersozialkasse",
                              $$v
                            )
                          },
                          expression: "formData.datei_kuenstlersozialkasse"
                        }
                      })
                ],
                1
              )
            : _vm._e(),
          !_vm.formData.kuenstlersozialkasse
            ? _c(
                "v-col",
                { staticClass: "ml-8", attrs: { cols: "12" } },
                [
                  _vm.readonly
                    ? [
                        _c("label", { staticClass: "primary--text" }, [
                          _vm._v(
                            "22.a. Ich arbeite als selbständiger Künstler oder befinde mich in einer künstlerischen Ausbildung"
                          )
                        ]),
                        _c("p", { staticClass: "text-preview" }, [
                          _vm._v(
                            _vm._s(
                              _vm.getStarterById(_vm.formData.berufsanfaenger)
                            )
                          )
                        ])
                      ]
                    : _c("v-select", {
                        attrs: {
                          label:
                            "22.a. Ich arbeite als selbständiger Künstler oder befinde mich in einer künstlerischen Ausbildung",
                          outlined: "",
                          dense: "",
                          placeholder: "Bitte Auswählen!",
                          "persistent-placeholder": "",
                          items: _vm.starters,
                          "item-text": "text",
                          "item-value": "value",
                          rules: [_vm.rules.required_boolean]
                        },
                        on: {
                          input: function(v) {
                            return _vm.saveFieldValue("berufsanfaenger", v)
                          }
                        },
                        model: {
                          value: _vm.formData.berufsanfaenger,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "berufsanfaenger", $$v)
                          },
                          expression: "formData.berufsanfaenger"
                        }
                      })
                ],
                2
              )
            : _vm._e(),
          !_vm.formData.kuenstlersozialkasse && _vm.formData.berufsanfaenger
            ? _c(
                "v-col",
                { staticClass: "pt-0", attrs: { cols: "12" } },
                [
                  _c("p", { staticClass: "file-label ml-8 mb-0" }, [
                    _vm._v(
                      "22.b. Bitte Ausbildungsnachweis wie bspw. Diplom hochladen, wobei der Abschluss frühestens 2018 erfolgt sein muss; alternativ können Nachweise über entsprechende Engagements ab dem Jahr 2018 hochgeladen werden, z.B. Verträge, Honorarabrechnungen (in einem PDF mit max. 4MB)"
                    )
                  ]),
                  _vm.readonly
                    ? _c("p", { staticClass: "text-preview ml-8" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formData
                              .datei_berufsanfaenger_ausbildungsnachweis
                              ? _vm.formData
                                  .datei_berufsanfaenger_ausbildungsnachweis
                                  .name
                              : ""
                          )
                        )
                      ])
                    : _c("v-file-input", {
                        attrs: {
                          outlined: "",
                          dense: "",
                          accept: "application/pdf",
                          rules: [
                            _vm.rules.required,
                            _vm.rules.valid_file_size(4),
                            _vm.rules.valid_file(_vm.fileCodes.PROOF_TRAINING)
                          ]
                        },
                        on: {
                          change: function(v) {
                            return _vm.onSelectFile(
                              "datei_berufsanfaenger_ausbildungsnachweis",
                              v
                            )
                          }
                        },
                        model: {
                          value:
                            _vm.formData
                              .datei_berufsanfaenger_ausbildungsnachweis,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formData,
                              "datei_berufsanfaenger_ausbildungsnachweis",
                              $$v
                            )
                          },
                          expression:
                            "formData.datei_berufsanfaenger_ausbildungsnachweis"
                        }
                      })
                ],
                1
              )
            : _vm._e(),
          !_vm.formData.kuenstlersozialkasse &&
          _vm.formData.berufsanfaenger === false
            ? _c(
                "v-col",
                { staticClass: "pt-0", attrs: { cols: "12" } },
                [
                  _c("p", { staticClass: "file-label ml-8 mb-0" }, [
                    _vm._v(
                      "22.b. Aktueller Selbständigkeitsnachweis vom Finanzamt oder Sozialversicherungsnachweis, dessen Tätigkeitsschlüssel mit 94 (darstellende Berufe) beginnt lt. Klassifizierung der Berufe 2010 (PDF, max. 4MB)"
                    )
                  ]),
                  _vm.readonly
                    ? _c("p", { staticClass: "text-preview ml-8" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formData.datei_selbststaendigkeitsnachweis
                              ? _vm.formData.datei_selbststaendigkeitsnachweis
                                  .name
                              : ""
                          )
                        )
                      ])
                    : _c("v-file-input", {
                        attrs: {
                          outlined: "",
                          dense: "",
                          accept: "application/pdf",
                          rules: [
                            _vm.rules.required,
                            _vm.rules.valid_file_size(4),
                            _vm.rules.valid_file(_vm.fileCodes.PROOF_SELF_EMP)
                          ]
                        },
                        on: {
                          change: function(v) {
                            return _vm.onSelectFile(
                              "datei_selbststaendigkeitsnachweis",
                              v
                            )
                          }
                        },
                        model: {
                          value: _vm.formData.datei_selbststaendigkeitsnachweis,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formData,
                              "datei_selbststaendigkeitsnachweis",
                              $$v
                            )
                          },
                          expression:
                            "formData.datei_selbststaendigkeitsnachweis"
                        }
                      })
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-col",
            {
              class: _vm.formData.gesamtbetrag_unter_60k && "pb-0",
              attrs: { cols: "12" }
            },
            [
              _vm.readonly
                ? [
                    _c("label", { staticClass: "primary--text" }, [
                      _vm._v(
                        "23. Mein zu versteuerndes Einkommen lag 2020 nicht über 60.000 €"
                      )
                    ]),
                    _c("p", { staticClass: "text-preview" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formData.gesamtbetrag_unter_60k ? "Ja" : "Nein"
                        )
                      )
                    ])
                  ]
                : _c("v-checkbox", {
                    attrs: {
                      label:
                        "23. Mein zu versteuerndes Einkommen lag 2020 nicht über 60.000 €",
                      dense: "",
                      rules: [_vm.rules.required]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("gesamtbetrag_unter_60k", v)
                      }
                    },
                    model: {
                      value: _vm.formData.gesamtbetrag_unter_60k,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "gesamtbetrag_unter_60k", $$v)
                      },
                      expression: "formData.gesamtbetrag_unter_60k"
                    }
                  })
            ],
            2
          ),
          _vm.formData.gesamtbetrag_unter_60k
            ? _c(
                "v-col",
                { class: !_vm.readonly && "pt-0", attrs: { cols: "12" } },
                [
                  _c("p", { staticClass: "file-label ml-8 mb-1" }, [
                    _vm._v(
                      "23.a. Steuerbescheid 2020, wenn nicht vorhanden 2019 oder alternativ Bestätigung des Finanzamts, wonach die Kleinunternehmerregelung (§ 19 Abs. 1 UStG) in Anspruch genommen wird (nicht älter als 2019) oder Nichtveranlagungsbescheinigung des Finanzamts (gültig ab 01.01.2019 oder später) oder Grundsicherungsbescheid (für das gesamte Jahr 2020)."
                    ),
                    _c("br"),
                    _vm._v(
                      "\nSollten auch diese Dokumente nicht beizubringen sein, kann auch eine ESt-Erklärung für das Jahr 2020 zusammen mit einer Bestätigung (ausgestellt durch einen Steuerberater oder eine vergleichbare steuerberatende Organisation mit Stempel und Unterschrift), wonach das zu versteuernden Einkommen "
                    ),
                    _c("span", { staticClass: "text-decoration-underline" }, [
                      _vm._v("des Antragstellers")
                    ]),
                    _vm._v(
                      " den Wert von 60.000 EUR nicht übersteigt eingereicht werden "
                    ),
                    _c("strong", { staticClass: "text-decoration-underline" }, [
                      _vm._v("oder in einem verkürzten Verfahren")
                    ]),
                    _vm._v(": GVL-Formular „"),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "https://gvl.de/sites/default/files/2021-08/Einkommensbestaetigung_GVL_JW.pdf",
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          "Bestätigung des zu versteuernden Einkommens für 2020"
                        )
                      ]
                    ),
                    _vm._v("“, wonach das zu versteuernde Einkommen "),
                    _c("span", { staticClass: "text-decoration-underline" }, [
                      _vm._v("des Antragsstellers")
                    ]),
                    _vm._v(" den Wert von 60.000 EUR nicht übersteigt. In "),
                    _c("span", { staticClass: "text-decoration-underline" }, [
                      _vm._v("beiden")
                    ]),
                    _vm._v(
                      " Fällen benötigen wir eine Bestätigung des Steuerberaters oder einer vergleichbaren steuerberatenden Organisation mit Stempel und Unterschrift."
                    )
                  ]),
                  _vm.readonly
                    ? _c("p", { staticClass: "text-preview ml-8" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formData.datei_gesamtbetrag_unter_60k
                              ? _vm.formData.datei_gesamtbetrag_unter_60k.name
                              : ""
                          )
                        )
                      ])
                    : _c("v-file-input", {
                        attrs: {
                          outlined: "",
                          dense: "",
                          accept: "application/pdf",
                          rules: [
                            _vm.rules.required,
                            _vm.rules.valid_file_size(4),
                            _vm.rules.valid_file(_vm.fileCodes.PROOF_TAX)
                          ]
                        },
                        on: {
                          change: function(v) {
                            return _vm.onSelectFile(
                              "datei_gesamtbetrag_unter_60k",
                              v
                            )
                          }
                        },
                        model: {
                          value: _vm.formData.datei_gesamtbetrag_unter_60k,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formData,
                              "datei_gesamtbetrag_unter_60k",
                              $$v
                            )
                          },
                          expression: "formData.datei_gesamtbetrag_unter_60k"
                        }
                      })
                ],
                1
              )
            : _vm._e(),
          _vm.formData.gesamtbetrag_unter_60k
            ? _c(
                "v-col",
                { staticClass: "pt-0", attrs: { cols: "12" } },
                [
                  _c("label", { staticClass: "primary--text ml-8" }, [
                    _vm._v("23.b. Steuerliche Identifikationsnummer")
                  ]),
                  _vm.readonly
                    ? _c("p", { staticClass: "text-preview ml-8" }, [
                        _vm._v(_vm._s(_vm.formData.steuer_ident_nr))
                      ])
                    : _c("v-text-field", {
                        staticClass: "ml-8",
                        attrs: {
                          autocomplete: "off",
                          outlined: "",
                          dense: "",
                          rules: [_vm.rules.required]
                        },
                        on: {
                          input: function(v) {
                            return _vm.saveFieldValue("steuer_ident_nr", v)
                          }
                        },
                        model: {
                          value: _vm.formData.steuer_ident_nr,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "steuer_ident_nr", $$v)
                          },
                          expression: "formData.steuer_ident_nr"
                        }
                      })
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _vm.readonly
                ? [
                    _c("label", { staticClass: "primary--text" }, [
                      _vm._v(
                        "24. Ich bin als Künstler*in  hauptberuflich im folgenden Bereich tätig"
                      )
                    ]),
                    _c("p", { staticClass: "text-preview" }, [
                      _vm._v(_vm._s(_vm.formData.hauptberuf_bereich))
                    ])
                  ]
                : _c("v-select", {
                    staticClass: "mt-3",
                    attrs: {
                      label:
                        "24. Ich bin als Künstler*in  hauptberuflich im folgenden Bereich tätig",
                      outlined: "",
                      dense: "",
                      placeholder: "Bitte Auswählen!",
                      "persistent-placeholder": "",
                      items: _vm.occupations,
                      rules: [_vm.rules.required]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("hauptberuf_bereich", v)
                      }
                    },
                    model: {
                      value: _vm.formData.hauptberuf_bereich,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "hauptberuf_bereich", $$v)
                      },
                      expression: "formData.hauptberuf_bereich"
                    }
                  })
            ],
            2
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _vm.readonly
                ? [
                    _c("label", { staticClass: "primary--text" }, [
                      _vm._v(
                        "25. Ich bin als ausübende(r) Künstler*in im Hauptberuf ausschließlich freiberuflich / solo-selbständig ODER auf Produktionsdauer beschäftigt"
                      )
                    ]),
                    _c("p", { staticClass: "text-preview" }, [
                      _vm._v(
                        _vm._s(_vm.formData.freiberuflich_solo ? "Ja" : "Nein")
                      )
                    ])
                  ]
                : _c("v-checkbox", {
                    attrs: {
                      label:
                        "25. Ich bin als ausübende(r) Künstler*in im Hauptberuf ausschließlich freiberuflich / solo-selbständig ODER auf Produktionsdauer beschäftigt",
                      dense: "",
                      rules: [_vm.rules.required]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("freiberuflich_solo", v)
                      }
                    },
                    model: {
                      value: _vm.formData.freiberuflich_solo,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "freiberuflich_solo", $$v)
                      },
                      expression: "formData.freiberuflich_solo"
                    }
                  })
            ],
            2
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _vm.readonly
                ? [
                    _c("label", { staticClass: "primary--text" }, [
                      _vm._v(
                        "26. Ich versichere, dass ich nicht Mitglied der Jury des vorliegenden Programms bin"
                      )
                    ]),
                    _c("p", { staticClass: "text-preview" }, [
                      _vm._v(_vm._s(_vm.formData.nicht_jury ? "Ja" : "Nein"))
                    ])
                  ]
                : _c("v-checkbox", {
                    attrs: {
                      label:
                        "26. Ich versichere, dass ich nicht Mitglied der Jury des vorliegenden Programms bin",
                      dense: "",
                      rules: [_vm.rules.required]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("nicht_jury", v)
                      }
                    },
                    model: {
                      value: _vm.formData.nicht_jury,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "nicht_jury", $$v)
                      },
                      expression: "formData.nicht_jury"
                    }
                  })
            ],
            2
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _vm.readonly
                ? [
                    _c("label", { staticClass: "primary--text" }, [
                      _vm._v(
                        "27. Ich versichere, dass ich für das beantragte Projekt innerhalb des viermonatigen Förderzeitraums kein anderes Stipendium des Bundes, eines Landes oder einer Kommune in Anspruch nehme/nehmen werde, dessen monatlicher Förderbetrag den Betrag von 625 € übersteigt. (Bagatellgrenze)"
                      )
                    ]),
                    _c("p", { staticClass: "text-preview" }, [
                      _vm._v(
                        _vm._s(_vm.formData.kein_stipendium ? "Ja" : "Nein")
                      )
                    ])
                  ]
                : _c("v-checkbox", {
                    attrs: {
                      label:
                        "27. Ich versichere, dass ich für das beantragte Projekt innerhalb des viermonatigen Förderzeitraums kein anderes Stipendium des Bundes, eines Landes oder einer Kommune in Anspruch nehme/nehmen werde, dessen monatlicher Förderbetrag den Betrag von 625 € übersteigt. (Bagatellgrenze)",
                      dense: "",
                      rules: [
                        _vm.rules.required_oneof(_vm.formData.mit_stipendium)
                      ]
                    },
                    on: {
                      change: function(v) {
                        return _vm.saveFieldValue("kein_stipendium", v)
                      }
                    },
                    model: {
                      value: _vm.formData.kein_stipendium,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "kein_stipendium", $$v)
                      },
                      expression: "formData.kein_stipendium"
                    }
                  })
            ],
            2
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _vm.readonly
                ? [
                    _c("label", { staticClass: "primary--text mtt-6" }, [
                      _vm._v(
                        "27.a. Ich erhalte noch bis zum 30.09.2021 (Laufzeitende des Stipendienprogramms) Gelder aus einem anderen Stipendienprogramms. Mir ist bekannt, dass die Auszahlung meines Stipendiums in diesem Fall erst im Oktober erfolgen wird"
                      )
                    ]),
                    _c("p", { staticClass: "text-preview" }, [
                      _vm._v(
                        _vm._s(_vm.formData.mit_stipendium ? "Ja" : "Nein")
                      )
                    ])
                  ]
                : _c("v-checkbox", {
                    attrs: {
                      label:
                        "27.a. Ich erhalte noch bis zum 30.09.2021 (Laufzeitende des Stipendienprogramms) Gelder aus einem anderen Stipendienprogramms. Mir ist bekannt, dass die Auszahlung meines Stipendiums in diesem Fall erst im Oktober erfolgen wird",
                      dense: "",
                      rules: [
                        _vm.rules.required_oneof(_vm.formData.kein_stipendium)
                      ]
                    },
                    on: {
                      change: function(v) {
                        return _vm.saveFieldValue("mit_stipendium", v)
                      }
                    },
                    model: {
                      value: _vm.formData.mit_stipendium,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "mit_stipendium", $$v)
                      },
                      expression: "formData.mit_stipendium"
                    }
                  })
            ],
            2
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v("28. Künstlerische Vita")
              ]),
              _c("p", { staticClass: "hint-label mb-1" }, [
                _vm._v(
                  "Bitte listen Sie hier mit insgesamt maximal 1000 Zeichen (ohne Leerzeichen, einfacher Text ohne Textauszeichnung wie Überschriften oder Gliederung) untereinander stichwortartig die wichtigsten Stationen aus Ihrem Lebenslauf auf (Bildung/Ausbildung, künstlerischer Werdegang/Stationen, ggf. Preise, Auszeichnungen u.ä."
                )
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.vita))
                  ])
                : _c("v-textarea", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      rows: "5",
                      rules: [
                        _vm.rules.required,
                        _vm.rules.maxLen(2000),
                        _vm.rules.maxRows(100)
                      ]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("vita", v)
                      }
                    },
                    model: {
                      value: _vm.formData.vita,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "vita", $$v)
                      },
                      expression: "formData.vita"
                    }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v("29. Konzerte, Produktionen")
              ]),
              _c("p", { staticClass: "hint-label mb-1" }, [
                _vm._v(
                  "Bitte listen Sie hier getrennt für 2019 und für 2020 mit insgesamt maximal 1.000 Zeichen (ohne Leerzeichen, einfacher Text) untereinander stichwortartig besonders wichtige Konzerte und/oder Produktionen auf."
                )
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.konzerte_produktionen))
                  ])
                : _c("v-textarea", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      rows: "5",
                      rules: [
                        _vm.rules.required,
                        _vm.rules.maxLen(2000),
                        _vm.rules.maxRows(10)
                      ]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("konzerte_produktionen", v)
                      }
                    },
                    model: {
                      value: _vm.formData.konzerte_produktionen,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "konzerte_produktionen", $$v)
                      },
                      expression: "formData.konzerte_produktionen"
                    }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v(
                  "30. Audio-/Videobeispiel oder Online-Rezension/Pressemitteilung"
                )
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.url_referenz1))
                  ])
                : _c("v-text-field", {
                    attrs: {
                      autocomplete: "off",
                      outlined: "",
                      dense: "",
                      type: "url",
                      "persistent-placeholder": "",
                      placeholder: "https://example.com",
                      pattern: "https://.*",
                      rules: [_vm.rules.required, _vm.rules.valid_url]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("url_referenz1", v)
                      }
                    },
                    model: {
                      value: _vm.formData.url_referenz1,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "url_referenz1", $$v)
                      },
                      expression: "formData.url_referenz1"
                    }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v(
                  "31. Audio-/Videobeispiel oder Online-Rezension/Pressemitteilung (optional)"
                )
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.url_referenz2))
                  ])
                : _c("v-text-field", {
                    attrs: {
                      autocomplete: "off",
                      outlined: "",
                      dense: "",
                      type: "url",
                      "persistent-placeholder": "",
                      pattern: "https://.*",
                      placeholder: "https://example.com",
                      rules: [_vm.rules.valid_url]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("url_referenz2", v)
                      }
                    },
                    model: {
                      value: _vm.formData.url_referenz2,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "url_referenz2", $$v)
                      },
                      expression: "formData.url_referenz2"
                    }
                  })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }